/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/locationState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 2:52:46 pm                           *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */

/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/opdHospitalState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 11:05:49 am                          *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */


 import Fuse from 'fuse.js';
import { base_axios_instance } from '../utils/axios_utils';
import axios from 'axios';
 const locationState = {
     state() {
         return {
             fetchingLocationData: true,
             fetchedLocationSuccessfuly: false,
             locationList: [],
             showLocationList: [],
             fuse: null,
         };
     },
     getters: {
         getLocationList(state) {
             return state.locationList;
         },
         getFuse(state) {
            return state.fuse;
         }
     },
     mutations: {
        makeFetchingDataTrue(state) {
            state.fetchingLocationData = true;
        },
        makeFetchingDataFalse(state) {
            state.fetchingLocationData = false;
        },
        makeFetchedSuccessFulyTrue(state) {
            state.fetchedLocationSuccessfuly = true;
        },
        uploadLocationList(state, locationList) {
            state.locationList = locationList;
        },
        uploadShowLocationList(state, locationList) {
        state.showLocationList = locationList;
        },
        uploadFuseData(state, fuse) {
            state.fuse = fuse;
        }
     },
     actions: {
         async loadLocationList(context, payload) {
            let addressList = null; 
            try {
                context.commit('makeFetchingDataTrue');
                addressList = await axios.get(`${process.env.VUE_APP_HBA_CUSTOMER}/user/states`);
                addressList = addressList.data.data.listOfState;
                context.commit('uploadLocationList', addressList);
                context.commit('uploadShowLocationList', addressList);
                const options = {
                keys: ['name'],
                includeScore: true // This can be omitted if the score is not needed
                };
                const fuse = new Fuse(context.getters.getLocationList, options);
                context.commit('uploadFuseData', fuse);
                } catch(error) {
                 console.log(error);
             }
         },
         searchLocation(context, payload) {
                
               let ans = context.getters.getFuse.search(payload.searchQuery).map(result => result.item);
               context.commit('uploadShowLocationList', ans);
         },
         removeLocationSearchQuery(context) {
             context.commit('uploadShowLocationList', context.getters.getLocationList);
         },
         switchActiveButtonBottomNavigation(context, payload) {
             context.commit('setSelectedIndex', payload.data.index);
         },
     },
 };
 export default locationState;